import React from "react";
import { Star, Users, Package, MapPin, Calendar } from "lucide-react";
import { useSiteSettings } from "../lib/hooks";

export default function SocialProofBar() {
  const s = useSiteSettings();
  if (!s) return null;

  const items = [
    { icon: Star, value: `${s.rating}/5`, label: "Customer Rating", pill: "★★★★★" },
    { icon: Users, value: s.happy_customers, label: "Happy Customers" },
    { icon: Package, value: s.products_count, label: "Products" },
    { icon: MapPin, value: s.cities_served, label: "Cities Served" },
    { icon: Calendar, value: `Since ${s.since_year}`, label: "Trusted Brand" },
  ];

  return (
    <section className="bg-neutral-900 text-white" data-testid="social-proof-bar">
      {/* Mobile: horizontal scroll strip, no wrapping */}
      <div className="md:hidden overflow-x-auto no-scrollbar">
        <div className="flex gap-3 px-4 py-5 min-w-max">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-2.5 bg-white/5 rounded-2xl px-3.5 py-2.5 flex-shrink-0">
              <div className="w-8 h-8 rounded-full bg-[#FF5A1F]/15 text-[#FF5A1F] flex items-center justify-center flex-shrink-0">
                <it.icon className="w-3.5 h-3.5" />
              </div>
              <div className="text-left leading-tight">
                <div className="font-display text-sm font-black whitespace-nowrap">{it.value}</div>
                <div className="text-[9px] uppercase tracking-[0.14em] text-neutral-400 whitespace-nowrap">{it.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* md+: 5-col grid */}
      <div className="hidden md:block max-w-[1400px] mx-auto px-8 py-8">
        <div className="grid grid-cols-5 gap-4">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF5A1F]/15 text-[#FF5A1F] flex items-center justify-center flex-shrink-0">
                <it.icon className="w-4 h-4" />
              </div>
              <div className="text-left">
                <div className="font-display text-xl font-black leading-none">{it.value}</div>
                <div className="text-[10px] uppercase tracking-widest text-neutral-400 mt-1">{it.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
